/**
 * Slick Carousel initialization for responsive device targeting
 * Supports desktop-only, mobile-only, or both device modes
 */

document.addEventListener('DOMContentLoaded', function() {
  let resizeTimer;
  
  /**
   * Initialize Slick carousels based on device targeting
   */
  function initSlickCarousels() {
    const isMobile = window.innerWidth <= 749;
    
    // Mobile-only carousels
    const mobileCarousels = document.querySelectorAll('.carousel--mobile > .group-block-content');
    handleCarousels(mobileCarousels, isMobile, {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      mobileFirst: true
    });
    
    // Desktop-only carousels
    const desktopCarousels = document.querySelectorAll('.carousel--desktop > .group-block-content');
    handleCarousels(desktopCarousels, !isMobile, {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    // Both devices carousels
    const bothCarousels = document.querySelectorAll('.carousel--both > .group-block-content');
    handleCarousels(bothCarousels, true, {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true
          }
        }
      ]
    });
  }
  
  /**
   * Handle carousel initialization and destruction
   * @param {NodeList} carousels - Carousel elements
   * @param {boolean} shouldInitialize - Whether to initialize or destroy
   * @param {Object} config - Slick configuration
   */
  function handleCarousels(carousels, shouldInitialize, config) {
    carousels.forEach(function(carousel) {
      if (shouldInitialize) {
        // Initialize if not already initialized
        if (!carousel.classList.contains('slick-initialized')) {
          // Ensure jQuery is available for Slick
          if (typeof $ !== 'undefined') {
            $(carousel).slick(config);
          } else {
            console.warn('jQuery not available for Slick carousel');
          }
        }
      } else {
        // Destroy if already initialized
        if (carousel.classList.contains('slick-initialized')) {
          if (typeof $ !== 'undefined') {
            $(carousel).slick('unslick');
          }
        }
      }
    });
  }
  
  /**
   * Initialize custom slick carousels with data attributes
   */
  function initCustomSlickCarousels(scope = document) {
    const customCarousels = scope.querySelectorAll('[data-slick-carousel]');
    
    customCarousels.forEach(function(carousel) {
      // Prevent duplicate initialization
      if (carousel.classList.contains('slick-initialized')) {
        return;
      }
      
      // Get configuration from data attributes
      const config = getSlickConfig(carousel);
      
      // Check device targeting
      const deviceTarget = carousel.dataset.deviceTarget || 'both';
      const isMobile = window.innerWidth <= 749;
      
      let shouldInitialize = false;
      if (deviceTarget === 'mobile') {
        shouldInitialize = isMobile;
      } else if (deviceTarget === 'desktop') {
        shouldInitialize = !isMobile;
      } else {
        shouldInitialize = true; // both
      }
      
      if (shouldInitialize && typeof $ !== 'undefined') {
        $(carousel).slick(config);
      }
    });
  }
  
  /**
   * Parse Slick configuration from data attributes
   * @param {Element} carousel - Carousel element
   * @returns {Object} Slick configuration
   */
  function getSlickConfig(carousel) {
    let config = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: false
    };
    
    // Parse data-config attribute if present
    const configString = carousel.dataset.config;
    if (configString) {
      try {
        const customConfig = JSON.parse(configString);
        config = { ...config, ...customConfig };
      } catch (error) {
        console.warn('Invalid Slick configuration, using defaults');
      }
    }
    
    // Parse individual data attributes
    const slidesToShow = carousel.dataset.slidesToShow;
    if (slidesToShow) config.slidesToShow = parseInt(slidesToShow);
    
    const slidesToScroll = carousel.dataset.slidesToScroll;
    if (slidesToScroll) config.slidesToScroll = parseInt(slidesToScroll);
    
    const dots = carousel.dataset.dots;
    if (dots !== undefined) config.dots = dots === 'true';
    
    const arrows = carousel.dataset.arrows;
    if (arrows !== undefined) config.arrows = arrows === 'true';
    
    const adaptiveHeight = carousel.dataset.adaptiveHeight;
    if (adaptiveHeight !== undefined) config.adaptiveHeight = adaptiveHeight === 'true';
    
    const autoplay = carousel.dataset.autoplay;
    if (autoplay === 'true') {
      config.autoplay = true;
      config.autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 3000;
    }
    
    return config;
  }
  
  /**
   * Handle responsive behavior for all carousels
   */
  function handleResponsiveCarousels() {
    // Handle device-targeted carousels
    initSlickCarousels();
    
    // Handle custom carousels
    initCustomSlickCarousels();
  }
  
  // Initialize on page load
  handleResponsiveCarousels();
  
  // Reinitialize on resize with debouncing
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResponsiveCarousels, 250);
  });
  
  // Shopify Theme Editor support
  document.addEventListener("shopify:section:load", function(e) {
    if (e.target) {
      initCustomSlickCarousels(e.target);
      initSlickCarousels();
    }
  });
  
  document.addEventListener("shopify:section:unload", function(e) {
    if (e.target) {
      const carousels = e.target.querySelectorAll('[data-slick-carousel], .carousel--mobile > .group-block-content, .carousel--desktop > .group-block-content, .carousel--both > .group-block-content');
      carousels.forEach(function(carousel) {
        if (carousel.classList.contains('slick-initialized') && typeof $ !== 'undefined') {
          $(carousel).slick('unslick');
        }
      });
    }
  });
  
  // Export functions for external use
  window.initSlickCarousels = initSlickCarousels;
  window.initCustomSlickCarousels = initCustomSlickCarousels;
});
